<template>
  <div class="replace-parts-record">
    <h1 class="item-title">{{ $t('asm_replace_parts_record.ljghjl') }}</h1>
    <div class="table-bd">
      <custom-table-expand
        ref="customTb1"
        index
        :rowId="getRowKeys"
        :data="tableList"
        :tableCode="tableCode"
        @sort="sortChange"
        @filter="filterChange"
        @exChange="exChange"
        expand-row-keys
        expand
        :slots="['expand', 'creator']"
      >
        <template slot="expand" slot-scope="scope">
          <div class="part-pic ub">
            <div style="margin-right: 60px" v-if="scope.row.beforeFileList && scope.row.beforeFileList.length">
              <h1>{{ $t('asm_replace_parts_record.ghqtp') }}</h1>
              <ul class="ubw">
                <li v-for="(item, index) in scope.row.beforeFileList" :key="index">
                  <img  @click="onViewImage(item.attachPath)"  :src="item.attachPath" alt />
                </li>
              </ul>
            </div>
            <div v-if="scope.row.afterFileList && scope.row.afterFileList.length">
              <h1>{{ $t('asm_replace_parts_record.ghhtp') }}</h1>
              <ul class="ubw">
                <li v-for="(item, index) in scope.row.afterFileList" :key="index">
                  <img  @click="onViewImage(item.attachPath)"  :src="item.attachPath" alt />
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!-- creator  查看案例 不要-->
        <!-- <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="onRowExpansion(scope.row)">{{ $t('p_caseOrderDetail_cha_kan_fa_piao') }}</el-button>
        </template> -->
      </custom-table-expand>
    </div>
    <h1 class="item-title" v-if="`${caseOrderType}`!=='50'">{{ $t('asm_replace_parts_record.khsysbpj') }}</h1>
    <div class="rating" v-if="`${caseOrderType}`!=='50'">
      <h1>{{ $t('asm_replace_parts_record.shi_yong_ping_ji') }}</h1>
      <el-rate v-model="ratingInfo.useRatingGrade" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate>
      <h1>{{ $t('asm_replace_parts_record.bao_yang_ping_ji') }}</h1>
      <el-rate v-model="ratingInfo.manageRatingGrade" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate>
      <h1 class="item-title" v-if="ratingInfo.imageList && ratingInfo.imageList.length">{{ $t('asm_replace_parts_record.she_bei_tu_pian') }}</h1>
      <ul class="ubw" v-if="ratingInfo.imageList && ratingInfo.imageList.length">
        <li v-for="(item, index) in ratingInfo.imageList" :key="index">
          <img :src="getAttachUrl(item)" alt />
        </li>
      </ul>
    </div>
    <!-- 查看地图图片 -->
    <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTableExpand from '@/components/customTableExpand.vue';

export default {
  inject: ['getCaseInfo'],
  computed: {
    caseInfo() {
      return this.getCaseInfo();
    },
    tableCode() {
      if (this.orderType === 'caseOrder') {
        return 'replace_parts_record';
      } else {
        return 'replace_parts_record_order';
      }
    },
  },
  components: { customTableExpand },
  props: {
    orderTechnicianId: [Number, String],
    orderType: [String], // workOrder是工单  caseOrder是案例订单
    caseOrderType: [Number, String], // workOrder是工单  caseOrder是案例订单
    // workOrderId: [Number, String]
  },

  watch: {
    orderTechnicianId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
          this.getRatingInfo();
        }
      },
    },

    // workOrderId: function (val) {
    //   if (val && this.orderTechnicianId) {
    //     this.getTableList();
    //   }
    // },
  },

  data() {
    return {
      tableList: [],

      // 发票列表
      invoiceList: [],
      expandedlist: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.orderPartId;
      },
      ratingInfo: {},
      dialogVisibleImage: false,
      dialogImageUrl: '',
    };
  },
  mounted() {
    this.initDialog();
    // this.getTableList();
    // this.getRatingInfo();
  },
  methods: {
    initDialog: function () {},

    getTableList: function () {
      this.$getJSON(apis.workOrderPartList, {
        // orderTechnicianId: this.orderTechnicianId,
        workOrderId: this.caseInfo.workOrderId,
      }).then((res) => {
        this.tableList = res.data || [];
      });
    },
    exChange: function (row) {
      this.getAttachList(row);
    },
    // 查看图片
    onViewImage: function (url) {
      this.dialogVisibleImage = true;
      this.dialogImageUrl = url;
    },
    // 获取零件变更图片
    getAttachList: async function (item) {
      if (!item.orderPartId) {
        return;
      }
      await Promise.all([this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.old`), this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.new`)]).then(([beforeFileList, afterFileList]) => {
        beforeFileList.data.map(f => this.getAttachUrl(f));
        afterFileList.data.map(f => this.getAttachUrl(f));
        this.$set(item, 'beforeFileList', beforeFileList.data);
        this.$set(item, 'afterFileList', afterFileList.data);
      });
    },
    getRatingInfo: function () {
      this.$getJSON(apis.ratingDeviceInfo, {
        // orderTechnicianId: this.orderTechnicianId,
        bodyNum: this.caseInfo.bodyNum,
        workOrderId: this.caseInfo.workOrderId,
      }).then((res) => {
        this.ratingInfo = res.data || {};
        if (this.ratingInfo.ratingImg) {
          this.$getAttachFileList(this.ratingInfo.ratingImg).then((imageList) => {
            this.ratingInfo.imageList = imageList;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.replace-parts-record {
  .el-table__expanded-cell {
    padding: 0;
  }
  .record-detail {
    padding: 20px 0;
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
